var portfolio = {
	addTransactionAction: "Agregar transacción",
	topFlopTitle: "Posición superior/Inferior",
	breakdownsTitle: "Información de desglose",
	assetClassBreakdownTitle: "Clases de activos",
	currencyBreakdownTitle: "Monedas",
	sectorBreakdownTitle: "Sectores",
	sectorBreakdownSubtitle: "Ponderación del portafolio total",
	evaluationChartTitle: "Valor del portafolio ",
	unrealizedPerformancePositionsTitle: "Rendimiento no realizado",
	weightPositionsTitle: "Peso del portafolio",
	editPortfolioAction: "Editar portafolio",
	deletePortfolioAction: "Eliminar portafolio",
	createPortfolioAction: "Crear portafolio",
	addPortfolioAction: "Crear portafolio",
	editTransactionAction: "Editar transacción",
	deleteTransactionAction: "Eliminar transacción",
	errorAlertLabel: "Ocurrió un error.",
	transactionLimitExceeded: "Se ha superado el límite de transacciones",
	portfolioLimitExceeded: "Se ha superado el límite de portafolios",
	info: "Información",
	noPositionsAlert: "El portafolio no contiene ninguna posición, agregue una transacción de compra",
	noTransactionsAlert: "El portafolio no contiene ninguna transacción, agregue una transacción de compra",
	noPortfolios: {
		title: "Info",
		message: "No portfolio has been created yet. Please click on the \"Add portfolio\" button and fill out the form to create a portfolio."
	},
	tab: {
		overview: "Descripción general",
		positions: "Posiciones",
		transactions: "Transacciones",
		news: "Noticias"
	},
	showActions: "Mostrar acciones"
};
var es = {
	portfolio: portfolio
};

export { es as default, portfolio };
